import {useEffect, useState} from "react"
import {useNavigate, useParams, useLocation} from "react-router-dom"

import {PaymentSucceeded} from "./PaymentSucceeded"
import {UKDirectDebitProcessing} from "./UKDirectDebitProcessing"
import {PaymentBeingProcessing} from "./PaymentBeingProcessing"
import {PaymentFailed} from "./PaymentFailed"
import {PaymentVoucherOXXOOutstanding} from "./PaymentVoucherOXXOOutstanding"

import {useAnalytics} from "@indebted/analytics"
import {PaymentConfirmationTimeout} from "@indebted/components/PaymentConfirmationTimeout"
import {ErrorPage} from "@indebted/components/Error"
import {LoadingPage} from "@indebted/components/Loading"
import {paymentAPI} from "@indebted/api/paymentAPI"

function PaymentStatusPage() {
	const {paymentID} = useParams()
	const location = useLocation()
	const i18n = location?.state?.I18n
	const paymentMethod = location?.state?.PaymentMethod
	const {track} = useAnalytics()
	const [Component, setComponent] = useState(<LoadingPage I18n={i18n} />)
	const {secureCode} = useParams()
	const navigate = useNavigate()

	useEffect(() => {
		if (!paymentMethod) {
			navigate(`/${secureCode}`)
		}

		if (paymentMethod === "UKDirectDebit") {
			setComponent(<UKDirectDebitProcessing I18n={i18n} />)

			return
		}

		const confirmationTimeout = setTimeout(() => {
			if (i18n) {
				setComponent(<PaymentConfirmationTimeout I18n={i18n} />)
			} else {
				navigate(`/${secureCode}`)
			}
		}, 60000)

		paymentAPI
			.pollConfirmation(paymentID!)
			.then((result) => {
				track("PIFConfirmPageViewed", {
					Status: result.Status,
					SecureCode: secureCode,
				})
				const StatusComponent = paymentStatusComponent(result.Status)
				setComponent(<StatusComponent {...result} />)
				clearTimeout(confirmationTimeout)
			})
			.catch((error) => {
				setComponent(<ErrorPage message={error.Message} error={error} />)
				clearTimeout(confirmationTimeout)
			})
	}, [paymentID, secureCode, i18n, paymentMethod, navigate, track])

	return Component
}

function paymentStatusComponent(status) {
	const map = {
		Initiated: LoadingPage,
		Submitted: PaymentBeingProcessing,
		Succeeded: PaymentSucceeded,
		Failed: PaymentFailed,
		VoucherOXXOOutstanding: PaymentVoucherOXXOOutstanding,
	}

	return map[status] || (() => <ErrorPage message="Unknown payment status" />)
}

export {PaymentStatusPage}
